$('body').on('change', '.select-court-replace', function(event){
  var currentValue = $(this).val();

  $.ajax({
    method: "GET",
    url: $(this).data('url'),
    data: { court: currentValue }
  })
  .done(function(result){
    $('.select-debtor-replace').empty().append(result)
  })
})